import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/schology/left-purple-ellipse.webp";
import BgImg1 from "../../../images/case-studies/schology/right-purple-ellipse.webp";

function Behindthesceneanimal() {
  return (
    <section className="behind-the-scene-animal creation-step p-100">
      <div className="img-right-purple-create">
        <StaticImage
          src="../../../images/case-studies/schology/left-purple-ellipse-sec.webp"
          alt="TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={649}
          height={913}
        />
      </div>

      {/* <div className="img-right-light-green">
        <StaticImage
          src="../../../images/case-studies/schology/light-green-ellipse.webp"
          alt="TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={557}
          height={913}
        />
      </div> */}
      <Container>
        <Row className="mb-4 mb-md-5">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#202020" }}>
              From Concept to <span className="purple-box">Creation</span>
            </h2>
            <h3 style={{ color: "#202020" }}>
              TekRevol’s Step-by-Step Approach to Schology’s Development
            </h3>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="">
            <div className="behind-main">
              <div className="behind-flex">
                <div className="behind-box left-box">
                  <h5>Discovery & Research</h5>
                  <p>
                    We identified gaps in the educational technology space and
                    the need for a unified platform to streamline processes
                    across multiple stakeholders. In-depth market research was
                    conducted to understand the requirements for a multi-tenant
                    system capable of supporting customizable features for
                    various schools.
                  </p>
                </div>
                <div
                  className="num left-padd"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  01
                </div>
              </div>
            </div>
            <div className="behind-main">
              <div className="behind-flex">
                <div className="behind-box left-box">
                  <h5>Technology & Feature Integration</h5>
                  <p>
                    Schology integrates advanced features like content
                    management and real-time performance tracking to enhance
                    user engagement. The platform also includes a robust admin
                    dashboard for seamless management of users, content, and
                    activities across multiple schools.
                  </p>
                </div>
                <div
                  className="num left-padd"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  03
                </div>
              </div>
            </div>

            <div className="behind-main">
              <div className="behind-flex">
                <div className="behind-box left-box">
                  <h5>Post-Deployment Support</h5>
                  <p>
                    Post-launch, we provide continuous monitoring and updates
                    based on user feedback to improve platform performance and
                    engagement. Regular updates and enhancements ensure the
                    system remains aligned with the evolving needs of the
                    educational sector.
                  </p>
                </div>
                <div
                  className="num left-padd"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  05
                </div>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={2}
            lg={2}
            xl={2}
            xxl={2}
            className="text-center column-none"
          >
            <StaticImage
              src="../../../images/case-studies/schology/line-purple.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={16}
              height={1435}
            />
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="">
            <div className="behind-main">
              <div className="behind-flex">
                <div
                  className="num right-padd"
                  style={{
                    backgroundImage: `url(${BgImg1})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  02
                </div>
                <div className="behind-box right-box">
                  <h5>Design & Development</h5>
                  <p>
                    The design phase focused on creating a clean, modern UI/UX
                    for an intuitive user experience across all platforms. React
                    Native was chosen for mobile compatibility, while Python and
                    MongoDB powered the backend to provide a scalable, flexible
                    solution.
                  </p>
                </div>
              </div>
            </div>

            <div className="behind-main">
              <div className="behind-flex">
                <div
                  className="num right-padd"
                  style={{
                    backgroundImage: `url(${BgImg1})`,
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  04
                </div>
                <div className="behind-box right-box">
                  <h5>Deployment & Testing</h5>
                  <p>
                    During deployment, we ensured smooth customization and
                    performance adjustments for each school. Rigorous quality
                    assurance testing was performed to ensure all features
                    functioned seamlessly and the system met the performance
                    demands of multiple institutions.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Behindthesceneanimal;
